import React, { useEffect } from 'react';
import { setClientDomain } from './utils/Common';
import AuthProvider from "./contexts/auth/Provider";
import ThemeProvider from "./contexts/theme/Provider";
import './style/App.css';
// rutas
import Routes from './routes/routes';

const App = () => {
  useEffect(() => { setClientDomain(window.location.hostname); }, []);
  return (
    <ThemeProvider>
      <AuthProvider>
        <Routes />
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
